import type { Product } from "@/types";
import { Container, ProductImage } from "@/components/atoms";

export function ClinicalNote({ product }: { product: Product }) {
  if (!product.clinicalNote) return null;
  return (
    <Container className="py-12">
      <div className="flex flex-col items-center gap-6 rounded-3xl bg-healthy-blue/5 p-8 md:flex-row">
        <ProductImage
          src="https://firebasestorage.googleapis.com/v0/b/drburns-web.firebasestorage.app/o/about%2Fdr-burns.png?alt=media"
          alt="Dr. Elaine Burns"
          name="Dr. Burns"
          className="h-24 w-24 shrink-0 rounded-full"
          imgClassName="object-cover object-top"
        />
        <div>
          <blockquote className="text-lg italic text-night-blue/80">
            “{product.clinicalNote}”
          </blockquote>
          <p className="mt-3 font-condensed text-sm font-bold uppercase tracking-wide text-leaf-green-ink">
            AACM-Certified Physician · Arizona-Licensed Naturopathic Physician
          </p>
        </div>
      </div>
    </Container>
  );
}
